export const SHOULD_PROPAGATE_UP = true;
export const SHOULD_NOT_PROPAGATE_UP = false;

export class SkipActionHandlersError extends Error {
  constructor(message?: string) {
    super(message || 'Action handlers skipped');
    this.name = 'SkipActionHandlersError';
  }
}
